import _ from 'lodash';

import Continue from '../continue';
import ViewOrder from '../viewOrder';
import RequestOrderReturn from '../requestOrderReturn';
import CancelOrder from '../cancelOrder';
import DownloadQuote from '../downloadQuote';
import SubmitOrder from '../submitOrder';
import SendContract from '../sendContract';

import request from '../../../../utils/request';
import { CONSTANT } from '../../../../utils/constant';

const {
  KEYS: {
    CHANNELS: { TQ }
  }
} = CONSTANT;
const channelName = _.get(request.getProfile(), 'channelName', '');

const actions = {
  incomplete: [Continue, CancelOrder],
  quoteApproved: [ViewOrder, DownloadQuote],
  pendingValidation: [ViewOrder, CancelOrder],
  waitingOnCredit: [ViewOrder, CancelOrder],
  waitingOnSales: [Continue, ViewOrder, CancelOrder],
  contractSent: [ViewOrder],
  contractSigned: [ViewOrder],
  orderSubmitted: [ViewOrder],
  contractExpired: [ViewOrder, CancelOrder],
  validated: [ViewOrder],
  withConcierge: [ViewOrder],
  orderCanceled: [],
  implementationInProgress: [ViewOrder],
  waitingOnCompletionCall: [ViewOrder],
  orderInstalled: [ViewOrder]
};

export const salesRepActions = {
  incomplete: [Continue, CancelOrder],
  quoteApproved: [ViewOrder, DownloadQuote, CancelOrder],
  contractSent: [ViewOrder, DownloadQuote, CancelOrder],
  contractSigned: [ViewOrder, DownloadQuote, CancelOrder],
  contractExpired: [ViewOrder],
  orderSubmitted: [ViewOrder, DownloadQuote, CancelOrder],
  orderCanceled: [ViewOrder],
}

export const salesSupportActions = {
  quoteApproved: [ViewOrder],
  contractSent: [ViewOrder],
  contractSigned: [ViewOrder],
  contractExpired: [ViewOrder],
  orderSubmitted: [ViewOrder],
  orderCanceled: [ViewOrder],
}

if (channelName === TQ) {
  actions.quoteApproved = [DownloadQuote];
  actions.orderSubmitted = [];
}

export default actions;
